import React from "react";
import { useDispatch } from "react-redux";
import AddConfigurationModal from "./AddConfigurationModal";
import { add_Configuration } from "./AddConfig";
import * as configureAction from "../../actions/configureAction";

const ConfigurationModal = ({
  showAddConfigModal,
  setshowAddConfigModal,
  disabletextInput,
  titleTag,
  setTitleTag,
  addEditConfig,
  setaddEditConfig,
  create_configutation,
  refreshTable,
}) => {
  const dispatch = useDispatch();

  if (!showAddConfigModal) return null;

  const handleClose = () => {
    setTitleTag({});
    setaddEditConfig(false);
    setshowAddConfigModal(false);
  };

  const handleSave = (title, tags, functionID, configListID) => {
    if (disabletextInput) {
      add_Configuration(
        title,
        tags,
        functionID,
        titleTag,
        dispatch,
        configureAction,
        refreshTable,
      );
    } else {
      create_configutation(title, tags, configListID);
    }
  };

  return (
    <AddConfigurationModal
      openModal={showAddConfigModal}
      handleClose={handleClose}
      handleSave={handleSave}
      disabledtextInput={disabletextInput}
      titleTag={titleTag}
      addEditConfig={addEditConfig}
    />
  );
};

export default ConfigurationModal;